import styled from '@emotion/styled';
import { css } from '@emotion/core';
import {
	BaseCell,
	BaseHeader,
} from '../../../../flights/overview/ui/list/columns/Column';
import { Css, Responsive } from '../../../../../ui';
import { Color } from '../../../../../styles/Color';
import { solicitationListHeaderStyles } from './Column.styles';

interface ISolicitationTypeProps {
	type: string;
}

const styles = css`
	display: flex;
	width: 80px;
	max-width: 80px;
	margin-right: ${Css.pxToRem(40)};
	padding: 0;

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		margin-right: 0;
		padding-right: 0;
	}
`;

export const StyledHeader = styled(BaseHeader)`
	${styles}
	${solicitationListHeaderStyles}
	color: ${Color.Neutral6};

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		margin-right: 0;
		padding-right: 0;
	}
`;

export const StyledCell = styled(BaseCell)`
	${styles}
	padding: 0;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		grid-area: type;
		max-width: ${Css.pxToRem(78)};
	}
`;

const Type = styled.div`
	font-weight: 500;
	font-size: ${Css.pxToRem(16)};
	line-height: ${Css.pxToRem(19)};

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		inline-size: min-content;
		width: max-content;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: flex;
		flex-direction: column;
		justify-content: center;
		margin-bottom: ${Css.pxToRem(1)};
	}
`;

export function Header() {
	return <StyledHeader css={styles}>Type</StyledHeader>;
}

export function Cell({ type }: ISolicitationTypeProps) {
	return (
		<StyledCell css={styles}>
			<Type>{type}</Type>
		</StyledCell>
	);
}
